import '../styles/Home.css';


import Video from './Video';
export default function Home() {
  return (
    <div>
      <Video />
      </div>
  )
}
